import RichText from "@/components/atoms/rich-text/rich-text";

import Styles from "./trip-duration-info-style.module.css";

type TripDurationInformationProps = {
  multiTripTitle?: string;
  multiTripDescription?: string;
};

function TripDurationInformation({
  multiTripTitle = "",
  multiTripDescription = "",
}: Readonly<TripDurationInformationProps>) {
  return (
    <div
      className="flex flex-col items-center max-w-full w-full h-full rounded-radius-xxl py-spacing-m px-spacing-l gap-spacing-m bg-surface-neutral-option-1
                  md:max-w-[672px]  md:py-spacing-xxl md:px-spacing-xxxl md:gap-spacing-m
                  lg:max-w-[1200px] lg:gap-spacing-l"
    >
      {/* Multi Trip Title */}
      <h2
        className="font-header-font text-[26px] not-italic leading-[29.9px] text-text-title self-stretch
                  md:text-[39px] md:leading-[44.85px] w-full h-full"
      >
        {multiTripTitle}
      </h2>

      {/* Multi Trip Description */}
      <div
        className={`${Styles.DescriptionClass} w-full font-body-font font-semibold text-[18px] leading-[27px] not-italic text-[#000]`}
      >
        <RichText richText={`${multiTripDescription}`} />
      </div>
    </div>
  );
}

export default TripDurationInformation;
